import { createTheme, ThemeOptions } from '@material-ui/core'

import { adminThemeBreakpoints } from './breakpoints'
import {
  adminDarkPlaceholder,
  adminThemeDefaultProps,
  adminThemeStatus,
  adminThemeZIndex,
} from './customThemeProperties'
import { overrides } from './overrides'
import { adminDarkPalette, basePalette, dataVizPalette } from './palette'
import { adminThemeTypography } from './typography'

export const adminDarkOptions = {
  themeName: 'Admin Dark',
  palette: {
    ...basePalette,
    ...adminDarkPalette,
    ...dataVizPalette,
  },
  breakpoints: adminThemeBreakpoints,
  typography: adminThemeTypography,
  overrides: overrides,
  /** Legacy Properties. Avoid new usage. */
  ...adminDarkPlaceholder,
  ...adminThemeZIndex,
  ...adminThemeStatus,
  ...adminThemeDefaultProps,
} satisfies ThemeOptions

export const adminDark = /* @__PURE__ */ createTheme(adminDarkOptions)
